import manager from 'app/module46/component-manager.js';

manager.register('event-registration', (component, elements, attributes, properties) => {

	const {
		tableCount,
		amount
	} = elements;

	const {
		price
	} = attributes;

	if(tableCount) {

		function compute() {
			amount.innerHTML = (tableCount.value * price).toFixed(2) + ' $';
		}
		
		tableCount.addEventListener('keyup', compute);
		tableCount.addEventListener('change', compute);
		
		compute();
	}
});
